import React from "react";
import { I18n } from "react-redux-i18n";
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from '@common/components/modal';

import { getTestAttributes } from "@common/utils/tests";
import { Button } from "@common/components/Button";
import { PatientInviteProps, usePatientInviteController } from './controllers/main';
import { Flex } from "@common/components/Flex";
import { MessageBox } from "@common/components/MessageBox";

import "./patient-invite.styles.scss";

export const PatientInvite: React.FC<PatientInviteProps> = (props) => {
  const { onClose } = props;
  const {
    messageProps,
    closeMessage,
    onGoToPreviousStep,
    handleSubmit,
    submitting,
    component,
    submitBtnProps,
  } = usePatientInviteController(props);

  return (
    <>
      <MessageBox hideMessageBox={closeMessage} {...messageProps} />
      <Modal
        show
        animation={false}
        bsSize="medium"
        backdrop="static"
        bsClass="bootstrap modal"
        className="PatientInvite"
        onEscapeKeyDown={onClose}
        onHide={onClose}
      >
        <ModalHeader closeButton onHide={onClose}>
          <ModalTitle
            {...getTestAttributes({ id: 'lbl-ped-sec-close' })}
          >
            {I18n.t("Invite Patient to Complete a Questionnaire")}
          </ModalTitle>
        </ModalHeader>

        <ModalBody>
          {component}
        </ModalBody>
        <ModalFooter>
          <Flex justify="space-between">
            <Button
              disabled={submitting}
              {...getTestAttributes({ id: 'btn-bw-parent-cancel' })}
              onClick={onClose}
            >
              {I18n.t("Cancel")}
            </Button>
            <Flex>
              {onGoToPreviousStep && (
                <Button
                  disabled={submitting}
                  {...getTestAttributes({ id: 'btn-bw-parent-previous' })}
                  onClick={onGoToPreviousStep}
                >
                  {I18n.t("Previous")}
                </Button>
              )}
              <Button
                disabled={submitBtnProps?.disabled || submitting}
                bsStyle="primary"
                {...getTestAttributes({ id: 'btn-ped-sec-save' })}
                onClick={handleSubmit}
              >
                {submitting ? I18n.t("Loading") : (submitBtnProps?.text || I18n.t('Next'))}
              </Button>
            </Flex>
          </Flex>
        </ModalFooter>
      </Modal>
    </>
  );
};
